


























































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import AppletsCoupon from '@/components/coupon-select/appletsCoupon.vue'
@Component({
  components: {
    AppletsCoupon,
  },
})
export default class Coupons extends Vue {
  couponList: any[] = []
  isShow: boolean = false
  @Prop({
    type: Boolean,
    default: () => false,
  })
  showDemo!: boolean
  @Prop({
    type: Array,
    default: () => [],
  })
  AppCouponList!: any[]

  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'coupon',
        maxNumber: 1,
        isMore: true,
        styleType: 0,
      }
    },
  })
  CouponConfig!: any
  created() {
    this.couponList = this.AppCouponList
  }

  get showImg() {
    let img = ''
    switch (this.CouponConfig.styleType) {
      case 0:
        img = require('@/assets/images/couponStyle-1.jpg')
        break
    }
    return img
  }

  get showImgList() {
    let list = []
    for (let i = 0; i < this.CouponConfig.maxNumber; i++) {
      list.push(i)
    }

    return list
  }
  handleSelectCoupon() {
    this.isShow = !this.isShow
  }
  onChange(value) {
    // 点击了确定按钮
    console.log(value, this.CouponConfig.maxNumber);
    if (value.length > this.CouponConfig.maxNumber) {
      this.$Notice.warning({
        desc: '选择的优惠券不能超过显示个数',
      })
      this.couponList = []
      this.$emit('selectCouponList', [])
      return
    }
    this.$emit('selectCouponList', value)
    this.couponList = value
    console.log(this.couponList);
  }
  numberChange(value) {
    this.$emit('numberChange', value)
  }
  mounted() {}
}
